package br.com.texeratx.boardgametimeapp.core.network

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEvent
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import io.github.aakira.napier.Napier
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.delete
import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType

class ApiClient(
    private val client: HttpClient,
    private val sessionManager: SessionManager,
    baseUrl: String
) {
    private val baseUrl = baseUrl.removeSuffix("/")

    suspend fun get(endpoint: String): HttpResponse {
        val response = client.get("$baseUrl/$endpoint") { applyAuthHeader() }
        checkUnauthorized(response)
        return response
    }

    suspend fun post(endpoint: String, body: Any): HttpResponse {
        val response = client.post("$baseUrl/$endpoint") {
            contentType(ContentType.Application.Json)
            setBody(body)
            applyAuthHeader()
        }
        checkUnauthorized(response)
        return response
    }

    suspend fun put(endpoint: String, body: Any): HttpResponse {
        val response = client.put("$baseUrl/$endpoint") {
            contentType(ContentType.Application.Json)
            setBody(body)
            applyAuthHeader()
        }
        checkUnauthorized(response)
        return response
    }

    suspend fun patch(endpoint: String, body: Any): HttpResponse {
        val response = client.patch("$baseUrl/$endpoint") {
            contentType(ContentType.Application.Json)
            setBody(body)
            applyAuthHeader()
        }
        checkUnauthorized(response)
        return response
    }

    suspend fun delete(endpoint: String): HttpResponse {
        val response = client.delete("$baseUrl/$endpoint") { applyAuthHeader() }
        checkUnauthorized(response)
        return response
    }

    suspend fun postMultipart(
        endpoint: String,
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): HttpResponse {
        val response = client.post("$baseUrl/$endpoint") {
            applyAuthHeader()
            setBody(
                MultiPartFormDataContent(
                    formData {
                        append(
                            key = "file",
                            value = bytes,
                            headers = Headers.build {
                                append(HttpHeaders.ContentType, mimeType)
                                append(
                                    HttpHeaders.ContentDisposition,
                                    "form-data; name=\"file\"; filename=\"$fileName\""
                                )
                            }
                        )
                    }
                )
            )
        }

        return response
    }

    private suspend fun checkUnauthorized(response: HttpResponse) {
        if (response.status == HttpStatusCode.Unauthorized) {
            Napier.w("⚠️ 401 Unauthorized — sessão expirada, fazendo logout")
            sessionManager.clear()
            AppUiEventBus.publish(AppUiEvent.SessionExpired)
        }
    }

    private suspend fun HttpRequestBuilder.applyAuthHeader() {
        val session = sessionManager.load()
        val token = session?.token

        if (!token.isNullOrBlank()) {
            header("Authorization", "Bearer $token")
        }
        session?.activeClanId?.let { header("X-Clan-Id", it.toString()) }
    }
}
